module.exports = __webpack_public_path__ + "images/0255c8b69917fa28763af46a8df35427-IMG_7034.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_7034.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_7034.jpg
// module chunks = 0